/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOMServer from 'react-dom/server';
import ReactHtmlParser from 'react-html-parser';

class ReadMore extends Component
{
    constructor(props)
    {
        super(props);

        this.state = {
            isOpen: false,
        };
    }

    render()
    {
        const {
            children, max, textClass, ...props
        } = this.props;
        const { isOpen } = this.state;

        let largeText = '';

        if (!children)
        {
            return null;
        }
        if (typeof children !== 'string')
        {
            largeText = ReactDOMServer.renderToStaticMarkup(children);
        }
        else
        {
            largeText = children;
        }

        let text;
        let action = null;
        const btnClass = 'btn tw-text-center tw-uppercase font-sp tw-py-4 tw-px-8 tw-mx-auto tw-inline-block btn-gray tw-bg-gray-400 tw-text-gray-700 tw-mt-4 tw-w-full md:tw-w-auto';

        if (largeText.length > max && !isOpen)
        {
            text = (
                <div className={textClass}>
                    {ReactHtmlParser(largeText.slice(0, max))}...
                </div>
            );

            action = (
                <span
                    className={btnClass}
                    onClick={() => this.setState({ isOpen: true })}
                >
                    Read more
                </span>
            );
        }
        else if (largeText.length > max && isOpen)
        {
            text = (
                <div className={textClass}>
                    {ReactHtmlParser(largeText)}
                </div>
            );
            action = (
                <div
                    className={btnClass}
                    onClick={() => this.setState({ isOpen: false })}
                >
                    Read less
                </div>
            );
        }
        else
        {
            text = (
                <div className={textClass}>
                    {ReactHtmlParser(largeText)}
                </div>
            );
        }

        return (
            <div {...props} style={{ whiteSpace: 'pre-line' }}>
                {text}
                {action}
            </div>
        );
    }
}

ReadMore.defaultProps = {
    max: 50,
};

ReadMore.propTypes = {
    children: PropTypes.any.isRequired,
    max: PropTypes.number,
    textClass: PropTypes.string,
};

export default ReadMore;
